import {pick} from "../../utils/utils";
import {Sizes} from "../../core/constants/sizes";
import {ValueOf} from "../../types/interfaces";

export const ThemeSwitchSizes = pick(Sizes, ['_XS', '_S', '_M', '_L', '_XL'])
export type ThemeSwitchSizesType = `${ValueOf<typeof ThemeSwitchSizes>}`

export const ThemeSwitchClass = {
	root: 'gov-theme-switch',
	indicator: 'gov-theme-switch__indicator',
	label: 'gov-theme-switch__label',
	iconLight: 'gov-theme-switch__icon-light',
	iconDark: 'gov-theme-switch__icon-dark',
}

export const ATTRIBUTE_THEME_NAME = 'data-theme'
